<template>
    <div class="form-container">
      <h2>Formulario de Aliado</h2>
      <form @submit.prevent="guardarAliado" class="form">
        <div class="form-group">
          <label for="nombre">Nombre del Aliado:</label>
          <input type="text" id="nombre" v-model="nombre" required class="form-control">
        </div>
        <div class="form-group">
          <label for="nit">NIT:</label>
          <input type="text" id="nit" v-model="nit" required class="form-control">
        </div>
        <div class="form-group">
          <label for="ciudad">Ciudad:</label>
          <input type="text" id="ciudad" v-model="ciudad" class="form-control">
        </div>
        <div class="form-group">
          <label for="direccion">Dirección:</label>
          <input type="text" id="direccion" v-model="direccion" class="form-control">
        </div>
        <div class="form-group">
          <label for="telefono">Teléfono:</label>
          <input type="text" id="telefono" v-model="telefono" class="form-control">
        </div>
        <div class="form-group">
          <label for="observaciones">Observaciones:</label>
          <textarea id="observaciones" v-model="observaciones" class="form-control"></textarea>
        </div>
        <div class="button-group">
          <button type="submit" id="enviar" class="btn">Enviar</button>
          <button type="button" id="cancelar" @click="cancelar" class="btn">Cancelar</button>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  import Swal from "sweetalert2";
  import HttpService from "../../Servicios/HttpService";
  export default {
    data() {
      return {
        nombre: '',
        nit: '',
        ciudad: '',
        direccion: '',
        telefono: '',
        observaciones: ''
      };
    },
    methods: {
      guardarAliado() {
        const aliado2 = {
        nombre: this.nombre,
        nit:this.nit,
        ciudad:this.ciudad,
        direccion:this.direccion,
        telefono:this.telefono,
        observaciones:this.observaciones
      }
        let payload = {
          accion: "registrarAliado",
          aliado: aliado2, 
        };
        HttpService.registrar("reportes.php", payload).then((registrado) => {
          if (registrado) {
            Swal.fire({
              title: "Registro de formulario",
              text: "Registrado",
              icon: "success",
              confirmButtonText: "Aceptar",
            }).then(() => {
              window.location.reload();
            });
          }
        });
      
      },
      cancelar() {
        // Implementación de la función cancelar
      }
    }
  };
  </script>
  
  <style scoped>
  .form-container {
    max-width: 500px;
    margin: 0 auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  label {
    display: block;
    font-weight: bold;
  }
  
  input[type="text"],
  input[type="date"],
  input[type="tel"],
  select,
  textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }
  
  button {
    margin-right: 10px;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
  }
  
  #enviar {
    background-color: #4CAF50;
  }
  
  #cancelar {
    background-color: #eb535b;
  }
  
  button:hover {
    background-color: #45a049;
  }
  </style>